<template>
  <div class="container">
    <!-- 侧边栏 -->
    <vs-sidebar
        absolute
        :reduce="sidebarReduced"
        v-model="active"
        open
    >
      <template #logo>
        <img :src="require('@/assets/TJ.jpg')" alt="Logo" style="height:250px;width: auto;">
      </template>

      <!-- 展开/收起按钮，放在侧边栏中间偏右 -->
      <div class="sidebar-toggle-btn" @click="sidebarReduced = !sidebarReduced">
        <div class="gt-arrow" :class="{ expanded: !sidebarReduced }">
          <span class="line line-1"></span>
          <span class="line line-2"></span>
        </div>
      </div>

      <!-- 桥隧路网组 -->
      <vs-sidebar-group>
        <template #header>
          <vs-sidebar-item id="qsq" :arrow="!sidebarReduced">
            <template #icon>
              <i class="bx bxs-map-pin" ></i>
            </template>
            城市大规模桥隧群
          </vs-sidebar-item>
        </template>

        <!-- 子项：上海桥隧群 -->
        <vs-sidebar-item id="sh-bridges" @click.native="handleMenuClick('/sandbox')">
          <template #icon>
            <i class='bx bxs-network-chart'></i>
          </template>
          上海桥隧群
        </vs-sidebar-item>

        <!-- 子项：武汉桥隧群 -->
        <vs-sidebar-item id="wh-bridges" @click.native="handleMenuClick('/SandboxWuhan')">
          <template #icon>
            <i class='bx bxs-network-chart'></i>
          </template>
          武汉桥隧群
        </vs-sidebar-item>

        <!-- 子项：深圳桥隧群 -->
        <vs-sidebar-item id="sz-bridges" @click.native="handleMenuClick('/sandbox_shenzhen')">
          <template #icon>
            <i class='bx bxs-network-chart'></i>
          </template>
          深圳桥隧群
        </vs-sidebar-item>
      </vs-sidebar-group>

      

      <vs-sidebar-item id="traffic" @click.native="handleMenuClick('/trafficflow')">
        <template #icon>
          <i class='bx bxs-traffic' @click.native="handleMenuClick('/trafficflow')"></i>
        </template>
        交通流量
      </vs-sidebar-item>

      <!-- 重点桥隧组 -->
      <vs-sidebar-group>
        <template #header>
          <vs-sidebar-item :arrow="!sidebarReduced">
            <template #icon>
              <i class="bx bxs-message-alt-error bx-flip-horizontal"></i>
            </template>
            重点桥隧
          </vs-sidebar-item>
        </template>

        <vs-sidebar-item id="上海桥梁" @click.native="handleMenuClick('/ModelMain')">
          <template #icon>
            <i class="bx bxs-network-chart"></i>
          </template>
          上海桥梁
        </vs-sidebar-item>
        <vs-sidebar-item id="武汉桥梁" @click.native="handleMenuClick('/ModelMainwh')">
          <template #icon>
            <i class="bx bxs-network-chart"></i>
          </template>
          武汉桥梁
        </vs-sidebar-item>
      </vs-sidebar-group>


      <!-- 侧边栏底部 -->
      <template #footer>
        <vs-row justify="space-between">
          <vs-avatar badge-color="danger" badge-position="top-right">
            <i class="bx bx-bell"></i>
            <template #badge>28</template>
          </vs-avatar>
          <vs-avatar>
            <img :src="require('@/assets/R.png')" alt="Logo" style="height:100px;width: auto;">
          </vs-avatar>
        </vs-row>
      </template>
    </vs-sidebar>

    <!-- 地图部分 -->
    <div class="content">
      <h1>桥隧群平面路网</h1>
      <div id="mapContainer" class="map"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoadNet',
  data() {
    return {
      active: 'qsq',
      sidebarReduced: false,
      center: { lng: 121.5522, lat: 31.2612 },
      zoom: 15,
      tilt: 60,
      yangpuBridge: { lng: 121.5522, lat: 31.2612 },
      beihongBridge: { lng: 121.383095, lat:31.225226},
      xinjianTunnel: { lng: 121.5115, lat: 31.2425 },
      lupuBridge:{ lng:121.487448, lat:31.195209 },
      xupuBridge:{ lng:121.475887, lat:31.133654},
      nanpuBridge:{ lng:121.512356, lat:31.211022},
      xznlTunnel: { lng:121.498931, lat:31.197678},
      xiangyinTunnel: { lng:121.567548, lat:31.309388},
      jungongTunnel: { lng:121.571561, lat:31.277437},
      longyaoTunnel: { lng:121.474767, lat:31.171849},
      dapuTunnel: { lng: 121.483311, lat:31.194075},
      dalianTunnel:{ lng: 121.526566, lat: 31.252840},
      renminTunnel: { lng:121.506692, lat:31.235374},
      zhoujiazuiTunnel: { lng:121.572819, lat:31.296975},
      chuanyangheBridge: { lng:121.503612, lat:31.171595},
      beihengTunnel1:{ lng:121.392856, lat:31.225176},
      waibaiduBridge:{ lng:121.496866, lat:31.249111},
      beihengTunnel2:{ lng:121.478121, lat:31.250999},
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    // 统一菜单点击处理，折叠状态禁止跳转
    handleMenuClick(route) {
      this.$router.push(route);
    },
    // 兼容旧方法（调用 handleMenuClick）
    navigateTo(path) {
      this.handleMenuClick(path);
    },
    initMap() {
      const BMapGL = window.BMapGL;
      this.map = new BMapGL.Map('mapContainer', {
        enableDblclickZoom: false,
        enableScrollWheelZoom: true,
        enableInertialDragging: true
      });
      const centerPoint = new BMapGL.Point(this.center.lng, this.center.lat);
      this.map.centerAndZoom(centerPoint, this.zoom);
      this.map.setTilt(this.tilt);

      const mapTypeControl = new BMapGL.MapTypeControl();
      this.map.addControl(mapTypeControl);
      const navigationControl = new BMapGL.NavigationControl3D();
      this.map.addControl(navigationControl);
      const zoomControl = new BMapGL.ZoomControl();
      this.map.addControl(zoomControl);

      this.addMarker(this.yangpuBridge, '杨浦大桥', 'red','/model');
      this.addMarker(this.beihongBridge, '中环立交桥', 'red','/BeiHong');
      this.addMarker(this.xinjianTunnel, '新建路隧道', 'green','/model');
      this.addMarker(this.xznlTunnel, '西藏南路隧道', 'green','/model');
      this.addMarker(this.xiangyinTunnel, '翔殷路隧道', 'green','/model');
      this.addMarker(this.jungongTunnel, '军工路隧道', 'green','/model');
      this.addMarker(this.longyaoTunnel, '龙耀路隧道', 'green','/model');
      this.addMarker(this.dapuTunnel, '打浦路隧道', 'green','/model');
      this.addMarker(this.dalianTunnel, '大连路隧道', 'green','/model');
      this.addMarker(this.renminTunnel, '人民路隧道', 'green','/model');
      this.addMarker(this.zhoujiazuiTunnel, '周家嘴路隧道', 'green','/model');
      this.addMarker(this.beihengTunnel1, '北横通道沪定路入口', 'green','/model');
      this.addMarker(this.beihengTunnel2, '北横通道西藏北路入口', 'green','/model');
      this.addMarker(this.lupuBridge, '卢浦大桥', 'red','/model');
      this.addMarker(this.nanpuBridge, '南浦大桥', 'red','/model');
      this.addMarker(this.xupuBridge, '徐浦大桥', 'red','/model');
      this.addMarker(this.chuanyangheBridge, '川杨河桥', 'red','/model');
      this.addMarker(this.waibaiduBridge, '外白渡桥', 'red','/model');
    },
    addMarker(position, label, color, route) {
      const BMapGL = window.BMapGL;
      const iconUrl = color === 'red'
        ? 'https://img.icons8.com/?size=100&id=uxLzhY5aZWlD&format=png&color=000000'
        : 'https://img.icons8.com/?size=100&id=Mu1YJD4mtYC3&format=png&color=000000';
      
      const icon = new BMapGL.Icon(iconUrl, new BMapGL.Size(64, 64));
      const marker = new BMapGL.Marker(new BMapGL.Point(position.lng, position.lat), { icon });
      this.map.addOverlay(marker);

      const labelText = new BMapGL.Label(label, {
        offset: new BMapGL.Size(20, -10)
      });
      labelText.setStyle({
        color: '#333333',
        fontSize: '12px',
        fontWeight: 'bold',
        textShadow: '1px 1px 2px gray',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '4px',
        padding: '3px 6px'
      });

      marker.setLabel(labelText);

      marker.addEventListener('click', () => {
        this.$router.push(route);
      });
    }
  }
};
</script>

<style scoped>
/* 展开/收起按钮 */
.sidebar-toggle-btn {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;
}
.sidebar-toggle-btn:hover {
  background: #f0f5ff;
}

/* 大于号线条 */
.gt-arrow {
  width: 14px;
  height: 14px;
  position: relative;
  transition: transform 0.2s;
}
.gt-arrow.expanded {
  transform: rotate(180deg);
}
.line {
  position: absolute;
  width: 12px;
  height: 2.5px;
  background: #555;
  border-radius: 1px;
  top: 50%;
  left: 0;
  transform-origin: right center;
}
.line-1 {
  transform: rotate(-35deg) translateY(-50%);
}
.line-2 {
  transform: rotate(35deg) translateY(-50%);
}

/* 原有布局样式 */
.container {
  display: flex;
  height: 100vh;
}
.vs-sidebar {
  width: 250px;
}
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
  font-family: 'Arial', sans-serif;
  color: #333;
}
.map {
  height: 80vh;
  width: 90vw;
  margin-top: 20px;
  border: 2px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
h1 {
  margin-top: 20px;
  font-size: 2.5em;
  color: #4f83cc;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}
</style>